import type { FaireProductEntity } from "../../entity_types/product";

export const p_msfpthtfz9: FaireProductEntity = {
  token: "p_msfpthtfz9",
  type: "product",
  name: "All Purpose Salve",
  brandToken: "b_rvn46uxywb",
  brandName: "Holistic Homestead",
  imageUrl:
    "https://cdn.faire.com/fastly/d83b4840a2ba5d397601084ade8ada52cb4f9ea28bfb42f90d275e167dbc3171.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.93,
  description:
    "Our All Purpose Salve works great on minor cuts, scrapes, rashes, bug bites, or just to soothe chapped skin & lips. Crafted with herbs grown on our herb farm & organic oils. A must-have for every home's first aid kit. No essential oils, just pure plant power.\n\n1 oz. or 2 oz. Tin",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:10.525Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
